/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// react-router-dom components

// @mui material components

import ProfileInfoCard from "./ProfileInfoCard";
import ProfileComponentsCard from "./ProfileComponentsCard";
import DashboardLayout from "LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Skill90DashboardNavbar";
import SoftBox from "components/SoftBox";
import { Grid } from "@mui/material";

import { getData, putData } from "Utils/server";
import { getAuthorizationHeader } from "Utils/helpers";

/**
 *
 * @returns
 */
function UserEdit() {
  let href = window.location.href;
  if (!href) return;

  let userId = href.split("users/edit/")[1];
  userId = parseInt(userId);
  const [user, setUser] = useState(null);
  const [userRoles, setUserRoles] = useState(null);
  const [userPermissions, setUserPermissions] = useState(null);
  const [userPlatforms, setUserPlatforms] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);
  const [refreshProfileInfo, setRefreshProfileInfo] = useState(false);

  /**
   *
   */
  async function initData() {
    if (!userId || userId == "") return;

    let getUserEndpoint = `/api/v1/users/${userId}`;

    let response = await getData(getUserEndpoint, { Authorization: getAuthorizationHeader() });
    if (response != null) {
      let user = response.data[0];
      for (const key of Object.keys(user)) {
        if (key == "roles") {
          let userRoles = [];
          for (const role of response.data[0][key]) {
            userRoles.push(role.name);
          }

          setUserRoles(userRoles.join(", "));
        }
        if (key == "platforms") {
          let userPlatforms = [];
          for (const platform of response.data[0][key]) {
            userPlatforms.push(platform.name);
          }

          setUserPlatforms(userPlatforms.join(", "));
        }
        if (key == "permissions") {
          let userPermissions = [];
          for (const permission of response.data[0][key]) {
            userPermissions.push(permission.permission_group + "-" + permission.permission_name);
          }

          setUserPermissions(userPermissions.join(", "));
        }
      }

      setUser(response.data[0]);
    } else {
    }
  }

  const handleEditProfileComponents = async (e, component) => {
    e.preventDefault();
    if (component.action == "cancel") {
      if (component.data) {
        setUser(null);
        setUserRoles(null);
        setUserPermissions(null);
        setUserPlatforms(null);
        setSelectedTab(0);
        initData();
      }
      return;
    }
    if (component.action == "save") {
      const postProfileEndpoint = `/api/v1/users/${userId}/profile`;
      const setProfileResponse = await putData(postProfileEndpoint, component.data, {
        Authorization: getAuthorizationHeader(),
      });

      // if (setProfileResponse) {
      //   console.log("setPlatformsResponse", setProfileResponse);
      // }

      setUser(null);
      setUserRoles(null);
      setUserPermissions(null);
      setUserPlatforms(null);
      setSelectedTab(0);
      initData();
      return;
    }
    setSelectedTab(component.id);
  };

  const informProfile = (data) => {
    if (data.refresh) initData();
    if (data.changeTab || data.changeTab == 0) setSelectedTab(data.changeTab);
  };

  useEffect(() => {
    initData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        sx={{ paddingTop: "24px" }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={4} xl={4} container spacing={2}>
            <Grid item xs={12} md={12} xl={12} sx={{ maxHeight: "510px" }}>
              <ProfileInfoCard
                title="Profile Information"
                status={user ? user.status : null}
                description=""
                info={{
                  username: user ? user.username : "",
                  roles: userRoles ? userRoles : "",
                  firstName: user ? user.first_name : "",
                  lastName: user ? user.last_name : "",
                  email: user ? user.email : "",
                  password: user ? "*******" : "",
                }}
                elementsActions={[{ tab: "password", id: 2 }]}
                action={{ route: "#editProfile", tooltip: "Edit Profile" }}
                editHandler={handleEditProfileComponents}
              />
            </Grid>
            <Grid item xs={12} md={12} xl={12}>
              <ProfileInfoCard
                title="Platforms/Permissions Information"
                description=""
                info={{
                  platforms: userPlatforms ? userPlatforms : "",
                  permissions: userPermissions ? userPermissions : "",
                }}
                elementsActions={[
                  { tab: "platforms", id: 1 },
                  { tab: "permissions", id: 0 },
                ]}
                action={{ route: "", tooltip: "" }}
                editHandler={handleEditProfileComponents}
                refreshProfileInfo={refreshProfileInfo}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={8} xl={8} container justifyContent="left">
            <ProfileComponentsCard
              userId={userId}
              tab={selectedTab}
              informProfile={informProfile}
            ></ProfileComponentsCard>
          </Grid>
        </Grid>
      </SoftBox>
    </DashboardLayout>
  );
}

export default UserEdit;
